<template>
    <div>
        <div class="login-container">
            <div v-if="loginDisplay">
                <h2 class="title">Submit coupon</h2>
            </div>
            <form v-if="loginDisplay || signUpButtonShow" action="#" @submit.prevent="loginOrCreateAccount">
                <!-- <input type="hidden" name="remember" value="true"/> -->
                <div class="input-holder">
                    <label class="form-group-label" for="email-address">Email address</label>
                    <input
                        id="email-address"
                        v-model="emailInput"
                        placeholder="realeamil@gamo.com"
                        name="email"
                        type="email"
                        autocomplete="off"
                        required
                        ref="emailInput"
                        class="form-group-input" />
                </div>
                <div class="input-holder">
                    <label class="form-group-label" for="coupon">Coupon</label>
                    <input
                        id="coupon"
                        v-model="couponInput"
                        placeholder="abcd-123456"
                        name="coupon"
                        type="text"
                        autocomplete="off"
                        required
                        ref="couponInput"
                        class="form-group-input" />
                </div>

                <VButton type="submit" class="login-btn" @clickHandler="loginOrCreateAccount" :disabled="buttonDisabled">Submit</VButton>
            </form>
        </div>
        <Flash ref="show"/>
    </div>
</template>

<script>
import {api} from "@/mixins/axios";
import Flash from "@/components/Flash.vue";
import VButton from "@/components/atoms/VButton.vue";
import {baseURL} from "@/mixins/helpers";

export default {
    name: "Login",
    components: {
        Flash,
        VButton
    },
    data() {
        return {
            emailInput: "",
            loginDisplay: true,
            signUpButtonShow: false,
            signedUpSuccess: false,
            loginSuccess: false,
            createErrorMessage: [],
            errorMessageLogin: [],
            buttonDisabled: false,
            loggedInUserInfo: {
                username: '',
                portrait: ''
            },
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
            couponInput: null
        };
    },
    methods: {
        // Create account using API
        async loginOrCreateAccount() {
            if (this.buttonDisabled) return
            
            if (!this.reg.test(this.emailInput)) {
                // email validation
                this.$refs.show.showFlashError("Invalid Email Address");
                return null;
            }
            try {
                this.buttonDisabled = true
                const response = await api.post("/appsumo_redeem", {
                    email: this.emailInput, coupon: this.couponInput
                });
                if (response?.data.msg === "ok") {
                    localStorage.setItem('token', response.data.token);
                    api.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
                    
                    if (this.$route.params.board_id) {
                        this.$router.push(`/project/${this.$route.params.board_id}`)
                    } else {
                        this.$router.push(`/project/none`)
                    }

                } else {
                    this.$refs.show.showFlashError(JSON.stringify(result.data.msg));
                }
                this.buttonDisabled = false;
            } catch(err) {
                this.$refs.show.showFlashError(err?.response?.data?.msg);
                this.buttonDisabled = false
            }
        },
        // Create an account show / hide
        showCreateAccount() {
            this.signUpButtonShow = true;
            this.loginDisplay = false;
            this.$refs.emailInput.focus()
        },
        showLoginAccount() {
            this.signUpButtonShow = false;
            this.loginDisplay = true;
            this.$refs.emailInput.focus()
        },
        async getUser() {
            try {
                const response = await api.post("/user_me", {});
                if (response.data.msg === 'ok') {
                    this.emailInput = response.data.data.email
                }
            } catch (e) {
            }
        }
    },
    mounted() {
        if(localStorage.getItem('token')) {
            this.getUser()
        }
        if(this.$route.query.email) {
            this.emailInput = this.$route.query.email
        }
        if(this.$route.query.coupon) {
            this.couponInput = this.$route.query.coupon
        }
        this.$nextTick(() => this.$refs.emailInput.focus())

        // window.addEventListener('storage', e => {
        //     console.log(e?.storageArea?.token);
        //     if (e?.storageArea?.token) {
        //         window.location.reload()
        //     }
        // })
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser
        },
    }
};
</script>
<style scoped lang="scss">

.login-container {
    max-width: 500px;
    margin: 100px auto 0;
    background: var(--primary-bg);
    padding: 40px 50px;
    border-radius: 10px;
    font-weight: 400;

    .title {
        font-size: 30px;
        text-align: left;
        margin-bottom: 15px;
        font-weight: 400;
    }
    .subtitle {
        color: #FFFFFFBF;
        font-size: 18px;
    }

    .form-group-label {
        font-size: 16px;
    }

    .form-group-input {
        display: block;
        width: 100%;
        padding: 10px;
        font-size: 16px;
        border-radius: 7px;
        outline: none;
        background: var(--primary-bg);
        border: 0.5px solid var(--outline);
        color: var(--primary-text);

        &::placeholder {
            color: var(--placeholder);
            font-size: 18.2px;
            font-weight: 300;
        }

        &:focus {
            outline: 0.5px solid var(--outline-active);
        }
    }

    .login-btn {
        display: block;
        width: 100%;
        padding: 11px 10px;
        border: none;
        background: $blue-5;
        color: #FFFFFFE5;
        margin-top: 10px;
        font-size: 18px;
        border-radius: 7px !important;
        cursor: pointer;
        height: auto;

        &:hover {
            background-color: #4E8EF8;
        }
    }

    .flex-center {
        display: flex;
        justify-content: center;
        color: #B6B6B6;
        font-size: 16px;
        font-weight: 400;
        margin: 15px 0;
    }

    .login-with-sm {
        color: rgba(255, 255, 255, 0.90);
        font-size: 18px;
        font-weight: 400;
        border-radius: 7.8px;
        background: #565A5D;
        padding: 11px 10px;
        height: 30px;
        margin-bottom: 15px;
        &:hover {
            background-color: #505b63;
        }
        img {
            margin-right: 5px;
        }
    }

    .show-create-account {
        margin-bottom: 2px;
        margin-top: 20px;
        font-size: 18px;
        
        span {
            color: $purple-0;
            cursor: pointer;
            text-decoration: underline;
            user-select: none;
        }
    }
    .sing-up-btn {
        color: $blue-5;
        font-size: 18px;
    }
    .forgot-psw-btn {
        color: #9BDBFF;
        font-size: 14px;
    }

    .user-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;

        .subtitle {
            margin-top: 10px;
            margin-bottom: 0;
        }
    }

    &__username {
        background-color: #9E9E9E33;
        width: fit-content;
        padding: 0 5px;
        border-radius: 5px;
    }

    .portrait-container img {
        width: 84px;
        height: 84px;
        border-radius: 50%;
    }

    .input-holder {
        margin-bottom: 15px;
    }
}
</style>
